export const getFieldId = (name: string) =>
  `card-token-form-${name.replace('_', '-')}`;
